import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCallQueueMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sequentialTimeout?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  huntingAlgorithmType?: Types.InputMaybe<Types.HuntingAlgorithmType>;
  maxQueueLength?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  maxWaitingTime?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  acwLength?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  outgoingCallBarringOperator?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  outgoingCallBarringAdmin?: Types.InputMaybe<Array<Types.InputMaybe<Types.OutgoingCallBarring>>>;
  hasAddressBook?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  queueFull?: Types.InputMaybe<Types.CallQueueMedia>;
  queueTimeout?: Types.InputMaybe<Types.CallQueueMedia>;
  waiting?: Types.InputMaybe<Types.CallQueueMedia>;
  priority?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UpdateCallQueueMutation = { __typename?: 'Mutation', updateCallQueue?: { __typename?: 'SaveResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const UpdateCallQueueDocument = gql`
    mutation UpdateCallQueue($id: Int!, $name: String, $sequentialTimeout: Int, $huntingAlgorithmType: HuntingAlgorithmType, $maxQueueLength: Int, $maxWaitingTime: Int, $acwLength: Int, $outgoingCallBarringOperator: [OutgoingCallBarring], $outgoingCallBarringAdmin: [OutgoingCallBarring], $hasAddressBook: Boolean, $queueFull: CallQueueMedia, $queueTimeout: CallQueueMedia, $waiting: CallQueueMedia, $priority: Int) {
  updateCallQueue(
    id: $id
    name: $name
    sequentialTimeout: $sequentialTimeout
    huntingAlgorithmType: $huntingAlgorithmType
    maxQueueLength: $maxQueueLength
    maxWaitingTime: $maxWaitingTime
    acwLength: $acwLength
    outgoingCallBarringOperator: $outgoingCallBarringOperator
    outgoingCallBarringAdmin: $outgoingCallBarringAdmin
    hasAddressBook: $hasAddressBook
    queueFull: $queueFull
    queueTimeout: $queueTimeout
    waiting: $waiting
    priority: $priority
  ) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type UpdateCallQueueMutationFn = Apollo.MutationFunction<UpdateCallQueueMutation, UpdateCallQueueMutationVariables>;

/**
 * __useUpdateCallQueueMutation__
 *
 * To run a mutation, you first call `useUpdateCallQueueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallQueueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallQueueMutation, { data, loading, error }] = useUpdateCallQueueMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      sequentialTimeout: // value for 'sequentialTimeout'
 *      huntingAlgorithmType: // value for 'huntingAlgorithmType'
 *      maxQueueLength: // value for 'maxQueueLength'
 *      maxWaitingTime: // value for 'maxWaitingTime'
 *      acwLength: // value for 'acwLength'
 *      outgoingCallBarringOperator: // value for 'outgoingCallBarringOperator'
 *      outgoingCallBarringAdmin: // value for 'outgoingCallBarringAdmin'
 *      hasAddressBook: // value for 'hasAddressBook'
 *      queueFull: // value for 'queueFull'
 *      queueTimeout: // value for 'queueTimeout'
 *      waiting: // value for 'waiting'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useUpdateCallQueueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallQueueMutation, UpdateCallQueueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallQueueMutation, UpdateCallQueueMutationVariables>(UpdateCallQueueDocument, options);
      }
export type UpdateCallQueueMutationHookResult = ReturnType<typeof useUpdateCallQueueMutation>;
export type UpdateCallQueueMutationResult = Apollo.MutationResult<UpdateCallQueueMutation>;
export type UpdateCallQueueMutationOptions = Apollo.BaseMutationOptions<UpdateCallQueueMutation, UpdateCallQueueMutationVariables>;